import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import constants from 'src/constant.json';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  constructor(private breakpointObserver: BreakpointObserver) { }
  get patterns() {
    return {
      email: {
        pattern: constants.regex.validEmail,
        message: 'Enter a valid email',
      },
      userName: {
        pattern: '^([a-zA-Z]|[a-zA-Z][a-zA-Z0-9.,$; @]+)$',
        message: 'Enter a valid user name',
      },
    };
  }

  isMobileOrTablet(): Observable<boolean> {
    return this.breakpointObserver
      .observe(['(max-width: 1366px) and (hover: none) and (pointer: coarse)'])
      .pipe(map((result) => result.matches));
  }

}
